import { RouteObject } from "react-router-dom";
import insuanceMatserRouteList from "./routeList";
import { lazy } from "react";
import PrivateRoute from "../../Authentication/component/PrivateRoute";
import Loader from "../../utilis/component/SkeletonLoading/Loader";

const AddOrEditInsurance = lazy(()=>import("./insurance/AddOrEditInsurance"))
const InsuranceMaster = lazy(()=>import("./insurance"))
const InsurancePlanMaster=lazy(()=>import("./InsurancePlan/index"))
const AddOrEditPlan=lazy(()=>import("./InsurancePlan/AddOrEditPage"))
const InsurancePriceList=lazy(()=>import("./insurancePriceMaster/InsurancePriceList/index"))
const InsurancePriceAddOrEdit=lazy(()=>import("./insurancePriceMaster/AddOrEditPrice/index"))
const InsuranceDiscount=lazy(()=>import("./InsuranceDiscount/index"))
const AddOrEditDiscount=lazy(()=>import("./InsuranceDiscount/AddOrEdit"))
const InsuranceNetworkMaster=lazy(()=>import("./NetworkMaster/index"))
const AddOrEditNetwork=lazy(()=>import("./NetworkMaster/AddOrEditPage"))
const InsuranceType=lazy(()=>import("./InsuranceType/index"))
const AddOrEditInsuraceType=lazy(()=>import("./InsuranceType/AddOrEditType"))



const insuranceMasterRoutes: RouteObject[] = [
    {
       path:insuanceMatserRouteList.insurance,
       children:[
        {
            path:"",
            element:<PrivateRoute>
                        <Loader>
                            <InsuranceMaster/>
                        </Loader>
                    </PrivateRoute>
        },
        {
            path:insuanceMatserRouteList.addOrEdit,
            element:<PrivateRoute>
                        <Loader>
                            <AddOrEditInsurance/>
                        </Loader>
                    </PrivateRoute>
        }
       ]
    },
    {
        path: insuanceMatserRouteList.insurancePlanMasters,
        children: [
            {
                path: "",
                element: (
                    <PrivateRoute>
                        <Loader>
                            <InsurancePlanMaster />
                        </Loader>
                    </PrivateRoute>
                ),
            },
            {
                path: insuanceMatserRouteList.addOrEdit,
                element: (
                    <PrivateRoute>
                        <Loader>
                            <AddOrEditPlan />
                        </Loader>
                    </PrivateRoute>
                ),
            },
        ],
    },
    {
        path: insuanceMatserRouteList.insuranceType,
        children: [
            {
                path: "",
                element: (
                    <PrivateRoute>
                        <Loader>
                            <InsuranceType />
                        </Loader>
                    </PrivateRoute>
                ),
            },
            {
                path: insuanceMatserRouteList.addOrEdit,
                element: (
                    <PrivateRoute>
                        <Loader>
                            <AddOrEditInsuraceType />
                        </Loader>
                    </PrivateRoute>
                ),
            },
        ],
    },
    {
        path: insuanceMatserRouteList.insurancePriceMaster,
        children: [
            {
                path: "",
                element: (
                    <PrivateRoute>
                        <Loader>
                            <InsurancePriceList />
                        </Loader>
                    </PrivateRoute>
                ),
            },
            {
                path: insuanceMatserRouteList.PriceRateEdit,
                element: (
                    <PrivateRoute>
                        <Loader>
                            <InsurancePriceAddOrEdit />
                        </Loader>
                    </PrivateRoute>
                ),
            },
        ],
    },
    {
        path: insuanceMatserRouteList.insuranceDiscount,
        children: [
            {
                path: "",
                element: (
                    <PrivateRoute>
                        <Loader>
                            <InsuranceDiscount />
                        </Loader>
                    </PrivateRoute>
                ),
            },
            {
                path: insuanceMatserRouteList.addOrEdit,
                element: (
                    <PrivateRoute>
                        <Loader>
                            <AddOrEditDiscount />
                        </Loader>
                    </PrivateRoute>
                ),
            },
        ],
    },
    {
        path: insuanceMatserRouteList.networkMaster,
        children: [
            {
                path: "",
                element: (
                    <PrivateRoute>
                        <Loader>
                            <InsuranceNetworkMaster />
                        </Loader>
                    </PrivateRoute>
                ),
            },
            {
                path: insuanceMatserRouteList.addOrEdit,
                element: (
                    <PrivateRoute>
                        <Loader>
                            <AddOrEditNetwork />
                        </Loader>
                    </PrivateRoute>
                ),
            },
        ],
    }
];

export default insuranceMasterRoutes